import { Injectable } from '@angular/core';
import { GraphQlRequestService } from '@gelato-api-ui/core/api/services/graph-ql-request.service';
import { GenerateMockupRequest } from '@product-catalogue/src/lib/store-product-media/types/store-product-media';
import * as gql from 'gql-query-builder';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StoreProductMediaGraphQlService {
  constructor(private readonly graphQlRequestService: GraphQlRequestService) {}

  fetchMockupPreviewUrl(request: GenerateMockupRequest) {
    const operation = 'mockup';
    const variables = {
      width: { type: 'Float!', value: request.width },
      height: { type: 'Float!', value: request.height },
      format: { type: 'String', value: request.format },
      image_url: { type: 'String!', value: request.image_url },
      product_uid: { type: 'String!', value: request.product_uid },
      force_dimensions: { type: 'Boolean', value: request.force_dimensions },
    };

    if (request.scene_name) {
      variables['scene_name'] = { type: 'String!', value: request.scene_name };
    }
    if (request.scene_id) {
      variables['scene_id'] = { type: 'String!', value: request.scene_id };
    }

    const query = gql.query({
      operation,
      variables,
      fields: ['url'],
    });

    return this.graphQlRequestService.query(query, `${operation}`).pipe(
      map(response => response?.data?.[operation]?.url),
      catchError(() => of(null)),
    );
  }
}
